export interface City {
  _id?: string
  name: string
  status: 'active' | 'inactive'
  country: string
  region: string
  description: string
  createdAt?: string
  updatedAt?: string
  __v?: number
}

export interface CityResponse {
  content: City[]
  totalElements: number
  totalPages: number
  size: number
  number: number
}

export const initialCity: City = {
  name: '',
  status: 'active',
  country: '',
  region: '',
  description: '',
} 